import React, { useContext } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import UiContext from "@UiContext";
import PageContext from "@PageContext";
import WebProfileContext from "@WebProfileContext";
import useFindMenuGroup from "@micado-digital/react-ui/hooks/useFindMenuGroup";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useScrolling from "../../../hooks/useScrolling";
import Container from "../Container";
import Logo from "../Logo";
import Hamburger from "./Hamburger";
import DesktopMenu from "./DesktopMenu";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import Local from "@Local";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Header.styles";

const MobileMenu = loadable(() => import("./MobileMenu"));

const Header = () => {
	const css = styles();
	const [ui] = useContext(UiContext);
	const { mobileMenuOpen } = ui;
	const [profileData] = useContext(WebProfileContext);
	const { mail, phone } = profileData;
	const [pageData] = useContext(PageContext);
	const { lang } = pageData;
	const mainmenu = useFindMenuGroup("Hauptmenü");
	// const { layoutVariant } = pageData;
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const scrollPosition = useScrolling();
	const isScrolling = scrollPosition > 0;

	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	return (
		<div
			className={clsx(css.header, "mco-view-component-header", {
				[css.headerScrolling]: isScrolling
			})}
		>
			<Container className={clsx(css.container, "mco-view-component-header__container")}>
				<Logo />
				{!isMobile && <DesktopMenu items={mainmenu} />}
				<div className={clsx(css.contactIcons, "mco-view-component-header__contact-icons")}>
					{mail && (
						<a href={`mailto:${mail}`}>
							<img alt="" height={24} src="/img/icons/mail.svg" width={24} />
						</a>
					)}
					{phone && (
						<a href={`tel:${phone.replace(/\s/g, "")}`}>
							<img alt="" height={24} src="/img/icons/phone.svg" width={24} />
							<p className={clsx(css.phoneLabel, "mco-view-component-header__phone-label")}>
								<Local identifier="general.hotline" l={l} />
								{phone.replace("+43 ", 0)}
							</p>
						</a>
					)}
					{isMobile && <Hamburger />}
					{isMobile && mobileMenuOpen && <MobileMenu items={mainmenu} />}
				</div>
			</Container>
		</div>
	);
};

export default Header;
